<div class="page outlet" *ngIf="(partiesByPark$ | async) as partiesByPark">
  <h3 class="text-primary text-center text-md-start">
    Party Reservations
  </h3>
  <ng-container *ngIf="!errorCode; else pageError">
    <ng-container *ngIf="partiesByPark && partiesByPark.size; else noParties">
      <div class="row" *ngFor="let party of partiesByPark | keyvalue">
        <div class="col-12 col-sm-4" *ngIf="party.value[0].park as park">
          <div>
            <a [href]="park.url" target="_blank" class="text-decoration-none btn-link">
              <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
              {{park.name}}
            </a>
          </div>
          <div>
            <a class="text-decoration-none"
               *ngIf="park.phoneNumber"
               href="tel:{{ park.phoneNumber | phoneNumber:'noFormatting'}}">
              {{ park.phoneNumber | phoneNumber }}
            </a>
          </div>
          <p class="mb-0">
            {{ park.address?.streetAddress }} {{ park.address?.city }}, {{ park.address?.state }} {{ park.address?.zipCode }}
          </p>
          <button class="btn btn-primary w-100 my-2" [routerLink]="['/parks', park.urlSlug]">Book Now</button>
        </div>
        <div class="col-12 col-sm-8">
          <table class="table">
            <thead>
            <tr class="text-center">
              <th>View</th>
              <th>Date</th>
              <th>Time</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let p of party.value" class="text-center">
              <td>
                <a 
                  [routerLink]="['/parks', p.park.urlSlug, 'confirmation']" 
                  [queryParams]="{ bookingId: p.confirmation, paymentProcessorVersion: p?.paymentProcessorVersion}">
                  <fa-icon class="redeem-icon" [icon]="faReceipt"></fa-icon>
                </a>
              </td>
              <td>
                {{p.date | date : 'M/d/yyyy'}}
              </td>
              <td>
                {{ (p.startHour | time | date: 'shortTime')}}
                <span *ngIf="p.endHour">{{ ' - ' + (p.endHour | time | date: 'shortTime') }}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #pageError>
  <ua-error *ngIf="errorCode" [errorCode]="errorCode"></ua-error>
</ng-template>

<ng-template #noParties>
  <div class="text-center text-md-start fs-5">
    Please <a class="btn-link text-decoration-none fw-bold" [href]="'/parks'">book a party</a> to make a reservation.
  </div>
</ng-template>
